<span [hidden]="opened && hideafteropen" (click)="openModal()"><ng-content></ng-content></span>